
<div class="threedviewer">
  @if (isOldUniprotEntry) {
    <section class="notification">
      <notification-msg
        [type]="'warning'"
        [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
      </notification-msg>
    </section>
  }

  <div class="structureTitleBox">
    <div class="filledBox">
      <span class="title">Similar structures</span>
      <span class="paeDescription">
        Discover similar structures from multiple databases, including the Protein Data Bank (PDB), the AlphaFold Database clustered to 50% sequence identity (AFDB50), AllTheBacteria (ATBC), Big Fantastic Virus Database (BFVD), Viro3D, VAD and Kinetoplastid Parasites using <a (click)= "gaService.eventEmitter(
      'foldseek_clickthrough', 'FS_similar_structures', 'click', 'foldseek_url', 'Clicks on the foldseek link from the description of table')" href="https://github.com/steineggerlab/foldseek" target="_blank">Foldseek</a>.

    </span>
  </div>
</div>

<div class="stage-box" >
  <div class="frame-parent">
    <div>
      <div class="struct-table-wrapper">
        <div class="struct-table">
          @if (!foldseekService.isStructureRunning() && !foldseekService.isStructureFail() && (foldseekService.isPDBFoldseekCach() === false || foldseekService.isAFDBFoldseekCach() === false)) {
            <div>
              <div class="empty-state-box">
                <div class="">
                  <div class="be-the-first">Explore similar structures</div>
                  <div class="it-appears-that paeDescription">Structure search is powered by Foldseek, a tool for fast protein structure comparison. <br>
                  Start a structural similarity search to discover similar proteins.</div>
                </div>
                <div class="button">
                  <a  class="vf-button vf-button--secondary vf-button--sm" style="color: #3B6FB6"
                    (click)="startStructureSearch()">
                    Find similar structures
                  </a>
                </div>
              </div>
            </div>
          }

          <!-- for inprogress state *ngIf="foldseekService.isStructureRunning() && !foldseekService.isStructureFail() && foldseekService.hasAFDBData() == -1" -->
          @if (foldseekService.isStructureRunning() && (foldseekService.hasAFDBData() === -1 || foldseekService.hasPDBData() === -1)) {
            <div>
              <div class="empty-state-box">
                <div class="">
                  <div class="be-the-first">Structure similarity search in progress</div>
                  <div class="it-appears-that">The Foldseek structure similarity search is currently in progress. <br/>Please stand by, the search usually takes a few minutes to complete.</div>
                </div>
                <div>
                  <svg style="display: block;" width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                  </svg>
                </div>
              </div>
            </div>
          }

          <!-- For both the table we dont have similar structure *ngIf="foldseekService.isStructureCach() === true && !foldseekService.isStructureRunning() && (foldseekService.hasPDBData() == -1 && foldseekService.isPDBLoading() === false) && (foldseekService.hasAFDBData() == -1 && foldseekService.isAFDBLoading() === false) && !foldseekService.isStructureFail()" -->
          @if (foldseekService.isStructureCach() === true && !foldseekService.isStructureRunning() && (foldseekService.hasPDBData() == -1 && foldseekService.isPDBLoading() === false) && (foldseekService.hasAFDBData() == -1 && foldseekService.isAFDBLoading() === false) && !foldseekService.isStructureFail()) {
            <div>
              <div class="empty-state-box">
                <div class="">
                  <div class="be-the-first">No similar structures found</div>
                  <div class="it-appears-that">It appears there are no similar structures found.</div>
                </div>
              </div>
            </div>
          }

          <!-- For the search api error *ngIf="foldseekService.isStructureFail() && (foldseekService.hasPDBData() == -1 && foldseekService.isPDBLoading() === false) && (foldseekService.hasAFDBData() == -1 && foldseekService.isAFDBLoading() === false)" -->
          @if (foldseekService.isStructureFail() && (foldseekService.hasPDBData() == -1 && foldseekService.isPDBLoading() === false) && (foldseekService.hasAFDBData() == -1 && foldseekService.isAFDBLoading() === false)) {
            <div >
              <div class="empty-state-box">
                <div class="">
                  <div class="be-the-first">Search error</div>
                  <div class="it-appears-that">An error occurred while processing your Foldseek structure similarity search. Please try again later or contact us at afdbhelp&#64;ebi.ac.uk if the error persists.</div>
                </div>
                <div class="button">
                  <a  class="vf-button vf-button--secondary vf-button--sm" style="color: #3B6FB6"
                    (click)="startStructureSearch()"
                    target="_blank">
                    Find similar structures
                  </a>
                </div>
              </div>
            </div>
          }

          @if ((foldseekService.hasPDBData() === 1 || foldseekService.hasAFDBData() === 1) && !foldseekService.isStructureRunning() && (foldseekService.isPDBFoldseekCach() === true && foldseekService.isAFDBFoldseekCach() === true)) {
            <div class="struct-table">
              <mat-tab-group #tabGroup (selectedTabChange)="tabChanged($event)">
                <mat-tab class="mat-tab-title" [label]="''" [disabled]="foldseekService.isPDBLoading()">
                  <ng-template mat-tab-label>
                    PDB&nbsp;
                    @if (!foldseekService.isPDBLoading()) {
                      <span>
                        ({{ foldseekapiService.totalStructure() }})
                      </span>
                    }
                    @if (foldseekService.isPDBLoading()) {
                      <span  style="display: inline-block; width: 20px; margin-left: 8px;">
                        <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                        </svg>
                      </span>
                    }
                  </ng-template>
                  <ng-template matTabContent>
                    <app-pdb-tab [afdb_accession]="afdb_accession" [accession]="accession" (toggleClickedEvent)="superposeSliderToggleAFDB($event, accession)"></app-pdb-tab>
                  </ng-template>
                </mat-tab>
                <mat-tab class="mat-tab-title" [disabled]="foldseekService.isAFDBLoading()">
                  <ng-template mat-tab-label>
                    <div style="display: flex; flex-direction: column;">
                      <span>AFDB50&nbsp;</span>
                      <span>
                        ({{ foldseekapiService.totalAFDBStructure() }})
                      </span>
                    </div>
                    @if (foldseekService.isAFDBLoading()) {
                      <span  style="display: inline-block; width: 20px; margin-left: 8px;">
                        <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                        </svg>
                      </span>
                    }
                  </ng-template>
                  <ng-template matTabContent>
                    <app-afdb-tab [afdb_accession]="afdb_accession" [accession]="accession" (toggleClickedEvent)="superposeSliderToggleAFDB($event, accession)"></app-afdb-tab>
                  </ng-template>
                </mat-tab>
                <mat-tab class="mat-tab-title" [disabled]="foldseekapiService.isATBCLoading()">
                  <ng-template mat-tab-label>
                    AllTheBacteria&nbsp;
                    @if (foldseekService.totalAllBacteria() > 0) {
                      <span>({{ foldseekService.totalAllBacteria() }})</span>
                    }
                    @if (foldseekService.totalAllBacteria() === 0) {
                      <span>(0)</span>
                    }
                    @if (foldseekapiService.isATBCLoading()) {
                      <span  style="display: inline-block; width: 20px; margin-left: 8px;">
                        <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                        </svg>
                      </span>
                    }
                  </ng-template>
                  <!-- <ng-template matTabContent> -->
                  <app-allbacteria-tab [afdb_accession]="afdb_accession" [accession]="accession" (toggleClickedEvent)="superposeSliderToggleAFDB($event, accession)"></app-allbacteria-tab>
                <!-- </ng-template> -->
              </mat-tab>
              <mat-tab class="mat-tab-title" [disabled]="foldseekapiService.isBFVDLoading()">
                <ng-template mat-tab-label>
                  <div style="display: flex; flex-direction: column;">
                    <span>
                      Big Fantastic
                    </span>
                    <span> Virus Database&nbsp;
                      @if (foldseekService.totalBFVD() > 0) {
                        <span>({{ foldseekService.totalBFVD() }})</span>
                      }
                      @if (foldseekService.totalBFVD() === 0) {
                        <span>(0)</span>
                      }
                    </span>
                  </div>
                  @if (foldseekapiService.isBFVDLoading()) {
                    <span  style="display: inline-block; width: 20px; margin-left: 8px;">
                      <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                      </svg>
                    </span>
                  }
                </ng-template>
                <!-- <ng-template matTabContent> -->
                <app-bfvd-tab [afdb_accession]="afdb_accession" [accession]="accession" (toggleClickedEvent)="superposeSliderToggleAFDB($event, accession)"></app-bfvd-tab>
              <!-- </ng-template> -->
            </mat-tab>
            <mat-tab class="mat-tab-title" [disabled]="foldseekapiService.isNTDXLoading()">
              <ng-template mat-tab-label>
                <div style="display: flex; flex-direction: column;">
                  <span>
                    Kinetoplastid
                  </span>
                  <span> parasites&nbsp;
                    @if (foldseekService.totalNTDX() > 0) {
                      <span>({{ foldseekService.totalNTDX() }})</span>
                    }
                    @if (foldseekService.totalNTDX() === 0) {
                      <span>(0)</span>
                    }
                  </span>
                </div>
                @if (foldseekapiService.isNTDXLoading()) {
                  <span  style="display: inline-block; width: 20px; margin-left: 8px;">
                    <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                    </svg>
                  </span>
                }
              </ng-template>
              <app-ntdx-tab [afdb_accession]="afdb_accession" [accession]="accession" (toggleClickedEvent)="superposeSliderToggleAFDB($event, accession)"></app-ntdx-tab>
            </mat-tab>
            <mat-tab class="mat-tab-title" [disabled]="foldseekapiService.isVIROLoading()">
              <ng-template mat-tab-label>
                <div style="display: flex; flex-direction: column;">
                  <span>
                    Viro3D
                  </span>
                  <span>&nbsp;
                    @if (foldseekService.totalVIRO() > 0) {
                      <span>({{ foldseekService.totalVIRO() }})</span>
                    }
                    @if (foldseekService.totalVIRO() === 0) {
                      <span>(0)</span>
                    }
                  </span>
                </div>
                @if (foldseekapiService.isVIROLoading()) {
                  <span  style="display: inline-block; width: 20px; margin-left: 8px;">
                    <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                    </svg>
                  </span>
                }
              </ng-template>
              <app-viro-tab [afdb_accession]="afdb_accession" [accession]="accession" (toggleClickedEvent)="superposeSliderToggleAFDB($event, accession)"></app-viro-tab>
            </mat-tab>
            <mat-tab class="mat-tab-title" [disabled]="foldseekapiService.isVADLoading()">
              <ng-template mat-tab-label>
                VAD&nbsp;
                @if (foldseekService.totalVAD() > 0) {
                  <span>({{ foldseekService.totalVAD() }})</span>
                }
                @if (foldseekService.totalVAD() === 0) {
                  <span>(0)</span>
                }
                @if (foldseekapiService.isVADLoading()) {
                  <span  style="display: inline-block; width: 20px; margin-left: 8px;">
                    <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                    </svg>
                  </span>
                }
              </ng-template>
              <app-vad-tab [afdb_accession]="afdb_accession" [accession]="accession" (toggleClickedEvent)="superposeSliderToggleAFDB($event, accession)"></app-vad-tab>
            </mat-tab>
          </mat-tab-group>
        </div>
      }
    </div>


    <div class="superpose-wrapper">
      <div class="superpose-align-1">
        <div class="foldseek-pdb-entries-table-max">
          <div class="try-2-parent">
            <div [ngClass]="isColorby ? 'plddtcolor-strap' : 'noplddt-strap'">
            </div>
            <div class="frame-parent3">
              <div class="af-q5vsl9-f1-parent">
                <div class="seq-identity-entry">{{afdb_accession}}</div>
                <div class="current-entry">Current entry</div>
              </div>
              <div class="checkboxes-parent">
                <div class="colour-by-plddt">
                  <div class="vf-form__item vf-form__item--checkbox">
                    <input
                      #benign
                      type="checkbox"
                      id="colorby"
                      value="colorby"
                      class="vf-form__checkbox"
                      [checked]="isColorby"
                      (change)=" (!isColorby); setsuperpose_color()"
                      [(ngModel)]="isColorby"
                      />
                    <label for="colorby" class="colorby-label vf-form__label">Colour by pLDDT
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="frame-wrapper">
            <div class="superpose-parent">
              <div class="load-spinner">
                <svg id="loading-spinner" style="display: none;" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#3b6fb6" fill="#3B6FB6" />
                </svg>
              </div>
              <div id="superpose-viewer"></div>
            </div>
          </div>
        </div>

        @if ((foldseekService.hasPDBData() != -1 || foldseekService.hasAFDBData() != -1)) {
          <div class="foldseek-pdb-entries-table-max">
            <div class="aligned-in-3d-parent-export nonMobile">
              <div class="link-button">
                @if (superposeData.length) {
                  <div class="link-button-ex">
                    <a class="vf-button vf-button--primary vf-button--sm" style="color: #FFFFFF; width:98%;" (click)="exportSuperpose()">Download aligned coordinates (mmCIF) </a>
                  </div>
                }
                @if (superposeData.length === 0) {
                  <div class="link-button-ex">
                    <a class="vf-button vf-button--tertiary vf-button--sm" style="color: #FFFFFF; width:98%; cursor:not-allowed;">Download aligned coordinates (mmCIF) </a>
                  </div>
                }
              </div>
            </div>
          </div>
        }

      </div>
      @if ((foldseekService.hasPDBData() != -1 || foldseekService.hasAFDBData() != -1)) {
        <div class="superpose-align-2" >
          <div class="foldseek-pdb-entries-table-max">
            <div class="aligned-in-3d-parent">
              <div class="aligned-in-3d" style="display: flex; flex-direction: row; align-items:end;">Aligned in 3D
                <div class="label-tooltip">
                  <svg class="que-svg" viewBox="0 0 24 24" style="margin-top: -4px;">
                    <path fill="#373A36"
                      d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                  </svg>
                  <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left; line-height: 22.4px;">
                    Rotate and zoom structures in the 3D <br>viewer. Structures are aligned using alpha<br> carbon atoms as reference points. Once <br>aligned, RMSD values will appear in the<br> list below; lower values indicate greater <br>similarity between the two structures.
                  </span>
                </div>
              </div>
              <div class="link-button">
                @if (superposeData.length) {
                  <div class="link-button-no"><a (click) = "removeAllSuperposition()">Remove all</a></div>
                }
              </div>
            </div>
          </div>
          @if (!superposeData.length) {
            <div class="toggle-desc">
              Toggle structures in both PDB and AFDB tables to view and align them with the entry structure in the 3D viewer. You can also download the aligned coordinates of the toggled structures and the entry structure.
            </div>
          }
          <div class="aligned-structures">
            <div class="superposed-list"  [ngClass]="superposeData.length > 4 ? 'scrollable' : ''">
              @for (item of superposeData; track item; let i = $index) {
                <div class="superposed-1">
                  <div class="superposed-1-child"  [ngClass]="!item.isShow ? 'blurit' : 'notblurit'" [ngStyle]="{'background-color': item.color}"></div>
                  <div class="frame-container">
                    <div class="k36-i-parent" [ngStyle]="{'opacity': !item.isShow ? '0.5' : '1'}">
                      <div class="k36-i">
                        <a href="{{item.refLinkId}}" target="_blank">{{item.targetToShow}}</a>
                        <span class="rmsd">{{ item.rmsd }}Å</span></div>
                        @if (item.desc?.length <= 30) {
                          <div class="protein-ecdysoneless-homolog nonMobile">{{ item.desc }} </div>
                        }
                        @if (item.desc?.length > 30) {
                          <div class="label-tooltip">
                            <p class="descEllipse protein-ecdysoneless-homolog">{{item.desc.slice(0,30)}}... </p>
                                                    <span class="label-tooltip-text" style="width: 155px;
                                                    word-break: break-all;">{{item.desc}}</span>
                          </div>
                        }
                      </div>
                      <div class="buttons">
                        <div id="{{item.accession}}-visibility"></div>
                        @if (item.isShow) {
                          <img  id="{{item.accession}}-closeeye" style="display: block;" alt="" src="assets/img/eye.svg" class="open-eye" width="24" height="24" (click) ="toggleSupeposeVisibility($event, item)" />
                        }
                        @if (!item.isShow) {
                          <img  id="{{item.accession}}-closeeye" alt="" src="assets/img/closeeye.svg" class="closed-eye" width="24" height="24" (click) ="toggleSupeposeVisibility($event, item)"  />
                        }
                        <div class="close">
                          <div class="cross-close">
                            <svg (click)="removeSuperpose(item)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_2268_35092)">
                                <path d="M13.9794 12.4958C13.9142 12.4308 13.8625 12.3535 13.8272 12.2685C13.7919 12.1834 13.7738 12.0922 13.7738 12.0002C13.7738 11.9081 13.7919 11.8169 13.8272 11.7319C13.8625 11.6468 13.9142 11.5696 13.9794 11.5046L18.6918 6.79218C18.8773 6.59313 18.9783 6.32987 18.9735 6.05784C18.9687 5.78582 18.8585 5.52628 18.6661 5.33391C18.4737 5.14153 18.2142 5.03133 17.9422 5.02653C17.6701 5.02173 17.4069 5.1227 17.2078 5.30818L12.4954 10.0206C12.4304 10.0858 12.3532 10.1375 12.2681 10.1728C12.1831 10.2081 12.0919 10.2262 11.9998 10.2262C11.9077 10.2262 11.8166 10.2081 11.7315 10.1728C11.6465 10.1375 11.5692 10.0858 11.5042 10.0206L6.79182 5.30818C6.59278 5.1227 6.32951 5.02173 6.05749 5.02653C5.78547 5.03133 5.52593 5.14153 5.33355 5.33391C5.14118 5.52628 5.03098 5.78582 5.02618 6.05784C5.02138 6.32987 5.12235 6.59313 5.30782 6.79218L10.0202 11.5046C10.0854 11.5696 10.1371 11.6468 10.1724 11.7319C10.2077 11.8169 10.2259 11.9081 10.2259 12.0002C10.2259 12.0922 10.2077 12.1834 10.1724 12.2685C10.1371 12.3535 10.0854 12.4308 10.0202 12.4958L5.30782 17.2082C5.20466 17.3043 5.12192 17.4202 5.06453 17.549C5.00714 17.6778 4.97628 17.8169 4.9738 17.9578C4.97131 18.0988 4.99724 18.2389 5.05005 18.3696C5.10286 18.5004 5.18146 18.6191 5.28117 18.7188C5.38088 18.8185 5.49964 18.8971 5.63039 18.9499C5.76113 19.0028 5.90117 19.0287 6.04216 19.0262C6.18314 19.0237 6.32218 18.9929 6.45098 18.9355C6.57978 18.8781 6.6957 18.7953 6.79182 18.6922L11.5042 13.9798C11.5692 13.9146 11.6465 13.8629 11.7315 13.8276C11.8166 13.7923 11.9077 13.7741 11.9998 13.7741C12.0919 13.7741 12.1831 13.7923 12.2681 13.8276C12.3532 13.8629 12.4304 13.9146 12.4954 13.9798L17.2078 18.6922C17.4069 18.8776 17.6701 18.9786 17.9422 18.9738C18.2142 18.969 18.4737 18.8588 18.6661 18.6664C18.8585 18.4741 18.9687 18.2145 18.9735 17.9425C18.9783 17.6705 18.8773 17.4072 18.6918 17.2082L13.9794 12.4958Z" fill="#3B6FB6"/>
                              </g>
                              <defs>
                                <clipPath id="clip0_2268_35092">
                                  <rect width="14" height="14" fill="white" transform="translate(5 5)"/>
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }


      </div>
    </div>
  </div>
</div>
</div>

@if (!downloadService.isDownloadRunningPDB() && downloadService.isDownloadFailedPDB()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
    </app-status-message>
  </div>
}

@if (!downloadService.isDownloadRunningPDB() && !downloadService.isDownloadFailedPDB() && downloadService.isDownloadDonePDB()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download successful. <br />If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings." messageType="success">
  </app-status-message>
</div>
}

@if (!downloadService.isDownloadRunningAFDB() && downloadService.isDownloadFailedAFDB()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
    </app-status-message>
  </div>
}

@if (!downloadService.isDownloadRunningAFDB() && !downloadService.isDownloadFailedAFDB() && downloadService.isDownloadDoneAFDB()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText='Download successful. <br/> If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings.' messageType="success">
  </app-status-message>
</div>
}

@if (!downloadService.isDownloadRunningATBC() && downloadService.isDownloadFailedATBC()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
    </app-status-message>
  </div>
}

@if (!downloadService.isDownloadRunningATBC() && !downloadService.isDownloadFailedATBC() && downloadService.isDownloadDoneATBC()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText='Download successful. <br/> If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings.' messageType="success">
  </app-status-message>
</div>
}

@if (!downloadService.isDownloadRunningBFVD() && downloadService.isDownloadFailedBFVD()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
    </app-status-message>
  </div>
}

@if (!downloadService.isDownloadRunningBFVD() && !downloadService.isDownloadFailedBFVD() && downloadService.isDownloadDoneBFVD()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText='Download successful. <br/> If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings.' messageType="success">
  </app-status-message>
</div>
}

@if (!downloadService.isDownloadRunningNTDX() && downloadService.isDownloadFailedNTDX()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
    </app-status-message>
  </div>
}

@if (!downloadService.isDownloadRunningNTDX() && !downloadService.isDownloadFailedNTDX() && downloadService.isDownloadDoneNTDX()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText='Download successful. <br/> If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings.' messageType="success">
  </app-status-message>
</div>
}

@if (!downloadService.isDownloadRunningVAD() && downloadService.isDownloadFailedVAD()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
    </app-status-message>
  </div>
}

@if (!downloadService.isDownloadRunningVAD() && !downloadService.isDownloadFailedVAD() && downloadService.isDownloadDoneVAD()) {
  <div>
    <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText='Download successful. <br/> If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings.' messageType="success">
  </app-status-message>
</div>
}
</div>